import useToast from '#/common/hooks/useToast';
import { useNavigate } from 'react-router-dom';

export const useRedirectToRelatedFindingsConfirm = () => {
  const navigate = useNavigate();
  const { confirm } = useToast();

  const redirectToRelatedFindingsConfirm = async (findingIds: string[], woCount: number) => {
    if (!findingIds?.length || woCount <= 0) {
      return;
    }

    const sure = await confirm(
      'success',
      `${woCount} work orders were successfully closed. There are ${findingIds.length} findings related to them.`,
      ['Ignore', 'See Findings'],
    );

    if (!sure) return;

    const baseFilter = '/findings?filters=';

    let queryFilter = '';
    findingIds.forEach((id, index) => {
      if (index === 0) {
        queryFilter += `["id","=","${id}"]`;
        return;
      }
      queryFilter += `,"or",["id","=","${id}"]`;
    });

    const query = findingIds.length === 1 ? queryFilter : `[${queryFilter}]`;
    const redirectUrl = `${baseFilter}${query}`;

    navigate(redirectUrl, {
      replace: true,
    });
  };

  return { redirectToRelatedFindingsConfirm };
};

export const useRedirectToRelatedFindingConfirm = () => {
  const navigate = useNavigate();
  const { confirm } = useToast();

  const redirectToRelatedFindingConfirm = async (findingId: string) => {
    if (!findingId) return;

    const sure = await confirm(
      'success',
      `The work order was successfully closed. There is a finding related to it and its status should be changed to Resolved manually.`,
      ['Ignore', 'See Finding'],
    );

    if (!sure) return;

    const redirectUrl = `/findings/${findingId}`;

    navigate(redirectUrl, { replace: true });
  };

  return { redirectToRelatedFindingConfirm };
};
